import zbFile from './zb-file'

export default {
    path: 'fabiao',
    component: () => import(/*webpackChunkName: 'bidding-fabiao'*/ '@layout/empty'),
    children: [
        zbFile,
    ]
}